import { useNavigate, useSearchParams } from 'react-router-dom';
import { AnalysesPage } from '@practium/features/analyses';
import type { AnalysesPermissions, AnalysesTab } from '@practium/features/analyses';
import { useForBinding } from '@practium/features/forBinding';
import { usePermissions } from '@practium/features/permissions';
import { isAnalysesTab } from '../routes';

export const AnalysesPageClient = () => {
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const { isForBinding } = useForBinding();
	const tabParam = searchParams.get('tab');
	const initialTab: AnalysesTab = isAnalysesTab(tabParam) ? tabParam : 'soil';
	const { abilities } = usePermissions();

	const subject = isForBinding ? 'farmers-samples' : 'samples';
	const permissions: AnalysesPermissions = {
		canCreate: abilities.can('create', subject),
		canEdit: abilities.can('update', subject),
		canDelete: abilities.can('delete', subject),
	};

	const handleAddNew = (tab: AnalysesTab) => {
		navigate(`/analises/novo?type=${tab}`);
	};

	const handleViewItem = (tab: AnalysesTab, id: string) => {
		navigate(`/analises/ver?type=${tab}&id=${id}`);
	};

	const handleTabChange = (tab: AnalysesTab) => setSearchParams({ tab }, { replace: true });

	return (
		<AnalysesPage
			permissions={permissions}
			initialTab={initialTab}
			onAddNew={handleAddNew}
			onViewItem={handleViewItem}
			onTabChange={handleTabChange}
		/>
	);
};
